<template>
  <div>
    <div class="md-modal modal-msg md-modal-transition" v-bind:class="{'md-show':c_mdshow}">
      <div class="md-modal-inner">
        <div class="md-top">
          <button class="md-close" @click = 'closeModal'>Close</button>
        </div>
        <div class="md-content">
          <div class="confirm-tips">
            <slot name="msg"></slot>
          </div>

          <slot name="code"></slot>

          <div class="surplus-tips">
            <p>请使用另一台手机扫码支付（不支持使用本机扫码支付）</p>
          </div>

          <div class="btn-wrap">
            <slot name = "btnGroup"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class = 'md-overlay' v-if="c_mdshow"></div>
  </div>

</template>

<script>
    export default {
      props:['c_mdshow'],
      mounted () {
        window.scrollTo(0, 0)
      },
      computed: {
        //判断是否是微信浏览器
        isWeChatFun(){
          let ua = window.navigator.userAgent.toLowerCase();
          if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            return true;
          }else{
            return false;
          }
        }
      },
      methods:{
        closeModal(){
          this.$emit('c_close')
        }
      }
    }
</script>
<style scoped>
  .md-content{
    text-align: center;
  }
  .code{
    width:200px;
    height:200px;
  }
  @media only screen and (max-width: 767px) and (min-width: 320px){
    .md-modal {
      position: absolute;
      margin-top: 0;
      top: 5%;
    }
    .btn-wrap{
      display: block;
    }
  }
  /*提示*/
  .surplus-tips{
    display: none;
    line-height: 20px;
    text-align: left;
    padding-left: 50px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .surplus-tips{
      display: block;
      font-size: 13px;
      margin: 15px 0;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/PayCodeModal.vue